import { yodaCatalogueConstants } from "../constants";
import { yodaCatalogueService } from "../services";
import { yodaUtilsActions } from "./yodaUtils.actions";

export const yodaCatalogueActions = {
  getOne,
  getOneSwap,
  getAll,
  getAllSwap,
  addAll,
  addAllSwap,
  getOneCatalog,
  getOneCatalogSwap,
  clearOrderCatalog,
  sendLog,
  clearSwapItems,
};

function getOne(customerId, productId, seasonId) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaCatalogueService.getOne(customerId, productId, seasonId).then(
      (response) => {
        if (response) {
          if (response?.message) {
            dispatch(failure(response?.message));
          } else {
            dispatch(success(productId, response));
          }
        } else {
          dispatch(failure(""));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaCatalogueService.getOne",
      { customerId, productId, seasonId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaCatalogueConstants.GETONE_REQUEST };
  }

  function success(productId, item) {
    return {
      type: yodaCatalogueConstants.GETONE_SUCCESS,
      payload: { productId, item },
      meta: { trackView: true },
    };
  }

  function failure(error) {
    return { type: yodaCatalogueConstants.GETONE_FAILURE, payload: { error } };
  }
}

function getOneSwap(customerId, productId, seasonId) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaCatalogueService.getOneSwap(customerId, productId, seasonId).then(
      (response) => {
        if (response) {
          if (response?.message) {
            dispatch(failure(response?.message));
          } else {
            dispatch(success(productId, response));
          }
        } else {
          dispatch(failure());
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaCatalogueService.getOneSwap",
      { customerId, productId, seasonId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaCatalogueConstants.GETONESWAP_REQUEST };
  }

  function success(productId, item) {
    return {
      type: yodaCatalogueConstants.GETONESWAP_SUCCESS,
      payload: { productId, item },
      meta: { trackView: true },
    };
  }

  function failure(error) {
    return {
      type: yodaCatalogueConstants.GETONESWAP_FAILURE,
      payload: { error },
    };
  }
}

function getOneCatalog(customerId, catalogId, seasonId) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaCatalogueService.getOneCatalog(catalogId).then(
      (response) => {
        if (response != null && response.errors === undefined) {
          dispatch(success(catalogId, response));
          if (response.product) {
            dispatch(
              yodaCatalogueActions.getOne(
                customerId,
                response.product.id,
                seasonId,
              ),
            );
          }
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaCatalogueService.getOneCatalog",
      { customerId, catalogId, seasonId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaCatalogueConstants.GETONE_CATALOG_REQUEST };
  }

  function success(catalogId, item) {
    return {
      type: yodaCatalogueConstants.GETONE_CATALOG_SUCCESS,
      payload: { catalogId, item },
    };
  }

  function failure(error) {
    return {
      type: yodaCatalogueConstants.GETONE_CATALOG_FAILURE,
      payload: { error },
    };
  }
}

function getOneCatalogSwap(customerId, catalogId, seasonId) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaCatalogueService.getOneCatalogSwap(catalogId).then(
      (response) => {
        if (response != null && response.errors === undefined) {
          dispatch(success(catalogId, response));
          if (response.product) {
            dispatch(
              yodaCatalogueActions.getOneSwap(
                customerId,
                response.product.id,
                seasonId,
              ),
            );
          }
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaCatalogueService.getOneCatalogSwap",
      { customerId, catalogId, seasonId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaCatalogueConstants.GETONESWAP_CATALOG_REQUEST };
  }

  function success(catalogId, item) {
    return {
      type: yodaCatalogueConstants.GETONESWAP_CATALOG_SUCCESS,
      payload: { catalogId, item },
    };
  }

  function failure(error) {
    return {
      type: yodaCatalogueConstants.GETONESWAP_CATALOG_FAILURE,
      payload: { error },
    };
  }
}

function getAll(params) {
  const { seasonId, lineId, customerId } = params;
  const callback = (dispatch) => {
    dispatch(request());
    yodaCatalogueService.getAll(params).then(
      (response) => {
        if (response.results != null) {
          const {
            results,
            currentPage,
            size,
            totalCount,
            totalPages,
            ...filters
          } = response;
          dispatch(success(results, currentPage, size, totalCount, totalPages));
          dispatch(updateFilters(filters));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaCatalogueService.getAll",
      { seasonId, lineId, customerId },
      () => callback(dispatch),
    );

  function request() {
    return {
      type: yodaCatalogueConstants.GETALL_REQUEST,
    };
  }

  function success(catalogue, currentPage, size, totalCount, totalPages) {
    return {
      type: yodaCatalogueConstants.GETALL_SUCCESS,
      payload: {
        catalogue,
        currentPage,
        size,
        totalCount,
        totalPages,
      },
    };
  }

  function updateFilters(filters) {
    return {
      type: yodaCatalogueConstants.UPDATE_FILTERS,
      payload: { filters },
    };
  }

  function failure(error) {
    return { type: yodaCatalogueConstants.GETALL_FAILURE, payload: { error } };
  }
}

function getAllSwap(params) {
  const { seasonId, lineId, customerId } = params;

  const callback = (dispatch) => {
    dispatch(request());

    yodaCatalogueService.getAllSwap(params).then(
      (response) => {
        if (response.results != null) {
          const {
            results,
            currentPage,
            size,
            totalCount,
            totalPages,
            ...filters
          } = response;
          dispatch(success(results, currentPage, size, totalCount, totalPages));
          dispatch(updateFilters(filters));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaCatalogueService.getAllSwap",
      { seasonId, lineId, customerId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaCatalogueConstants.GETALLSWAP_REQUEST };
  }

  function success(catalogue, currentPage, size, totalCount, totalPages) {
    return {
      type: yodaCatalogueConstants.GETALLSWAP_SUCCESS,
      payload: { catalogue, currentPage, size, totalCount, totalPages },
    };
  }

  function updateFilters(filters) {
    return {
      type: yodaCatalogueConstants.UPDATE_FILTERS,
      payload: { filters },
    };
  }

  function failure(error) {
    return {
      type: yodaCatalogueConstants.GETALLSWAP_FAILURE,
      payload: { error },
    };
  }
}

function addAll(params) {
  const { seasonId, lineId, customerId } = params;

  const callback = (dispatch) => {
    dispatch(request());

    yodaCatalogueService.getAll(params).then(
      (response) => {
        if (response.results != null) {
          const { results, currentPage, size, totalCount, totalPages } =
            response;
          dispatch(success(results, currentPage, size, totalCount, totalPages));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaCatalogueService.addAll",
      { seasonId, lineId, customerId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaCatalogueConstants.ADDALL_REQUEST };
  }

  function success(catalogue, currentPage, size, totalCount, totalPages) {
    return {
      type: yodaCatalogueConstants.ADDALL_SUCCESS,
      payload: { catalogue, currentPage, size, totalCount, totalPages },
    };
  }

  function failure(error) {
    return { type: yodaCatalogueConstants.ADDALL_FAILURE, payload: { error } };
  }
}

function addAllSwap({ seasonId, lineId, customerId, page, pageSize }) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaCatalogueService
      .getAllSwap({ seasonId, lineId, customerId, page, pageSize })
      .then(
        (response) => {
          if (
            response.results !=
            null /* && response.results != undefined && response.results.length > 0 */
          ) {
            const { results, currentPage, size, totalCount, totalPages } =
              response;
            dispatch(
              success(results, currentPage, size, totalCount, totalPages),
            );
          } else {
            dispatch(failure(response));
          }
        },
        (error) => {
          dispatch(failure(error));
        },
      );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaCatalogueService.addAllSwap",
      { seasonId, lineId, customerId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaCatalogueConstants.ADDALLSWAP_REQUEST };
  }

  function success(catalogue, currentPage, size, totalCount, totalPages) {
    return {
      type: yodaCatalogueConstants.ADDALLSWAP_SUCCESS,
      payload: { catalogue, currentPage, size, totalCount, totalPages },
    };
  }

  function failure(error) {
    return {
      type: yodaCatalogueConstants.ADDALLSWAP_FAILURE,
      payload: { error },
    };
  }
}

function clearOrderCatalog() {
  return (dispatch) => {
    dispatch(clear());
  };

  function clear() {
    return { type: yodaCatalogueConstants.CLEAR_ORDER_CATALOG, payload: {} };
  }
}

function clearSwapItems() {
  return (dispatch) => {
    dispatch(clear());
  };

  function clear() {
    return { type: yodaCatalogueConstants.CLEAR_SWAP_ITEMS };
  }
}

function sendLog({ error, warning, information, debug }) {
  const payload = {
    Error: typeof error === "object" ? JSON.stringify(error) || "" : "",
    Warning: typeof warning === "object" ? JSON.stringify(warning) || "" : "",
    Information:
      typeof information === "object" ? JSON.stringify(information) || "" : "",
    Debug: typeof debug === "object" ? JSON.stringify(debug) || "" : "",
  };

  if (Object.values(payload).some((value) => value)) {
    yodaCatalogueService
      .sendLog(payload)
      .then((response) => {
        if (response.status === 204) {
          console.log("B2B log sent.");
        }
      })
      .catch((error) => {
        console.warn("B2B log error:", error);
      });
  }

  return (dispatch) => {
    dispatch(send());
  };

  function send() {
    return { type: yodaCatalogueConstants.SEND_LOG, payload };
  }
}
